import { render, staticRenderFns } from "./subtopicDetails.vue?vue&type=template&id=8b00e892&"
import script from "./subtopicDetails.vue?vue&type=script&lang=js&"
export * from "./subtopicDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports